import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/admin/guard';
import { RoleEditor } from '@/features/admin/roles/role-editor';

export const Route = createFileRoute('/_app/admin/roles/new')({
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'admin.roles');
  },
  component: () => <RoleEditor role={null} />,
});
